import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import styles from './Input.module.scss'

class Input extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {
      value: this.props.value || '',
      focused: this.props.focused || false,
      type: this.props.type
    }

    this.togglePassword = this.togglePassword.bind(this);
  }

  componentWillUpdate (nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: (nextProps.value !== false) ? nextProps.value : '' });
    }

    if (nextProps.type !== this.props.type) {
      this.setState({ type: (nextProps.type !== false) ? nextProps.type : 'text' });
    }
  }

  togglePassword () {
    this.setState({
      type: this.state.type === 'input' ? 'password' : 'input'
    })  
  }

  onFocus = () => {
    this.setState(state => ({
      focused: true
    }))
    if (this.props.onFocus) {
      this.props.onFocus(this.state.value, e)
    }
  }

  onBlur = (e) => {
    this.setState(state => ({
      focused: false
    }))
    if (this.props.onBlur) {
      this.props.onBlur(this.state.value, e)
    }
  }

  onChange = (e) => {
    let value = e.target.value

    // display an error if there's an empty value for a required field.
    // if (value) value = value.trim()
    if ((value === '' || !value) && this.props.required) {
      this.state.error = 'Required field.'
    } else {
      this.state.error = ''
    }

    // set state with the trimmed value
    this.setState(state => ({
      value: value
    }))
    // call onChange function if it exists
    if (this.props.onChange) {
      this.props.onChange(value, this.props.name && this.props.name)
    }
  }

  onReturn = (e) => {
    // capture return key event
    if (e.key === 'Enter') {
      if (this.props.clearOnReturn) {
        this.setState({ value: ''})
      }
      // call onReturn function if it exists
      if (this.props.onReturn) {
        this.props.onReturn(this.state.value)
      }
    }
  }

  clearInput = () => {
    const value = '';
    this.setState({ value: value });
    // call onChange function if it exists
    if (this.props.onChange) {
      this.props.onChange(value, this.props.name && this.props.name)
    }
  }

  render () {
    var inputClasses = classNames(styles.input, styles[this.props.design], {
      [styles.small]: this.props.size === 'small',
      [styles.focused]: this.state.focused,
      [styles.inactive]: this.props.inactive,
      [styles.error]: this.props.error || this.state.error
    }, this.props.className)

    return <div className={inputClasses}>
      {(this.props.design === 'label') && <label className={(this.state.type === 'time' || this.state.focused || this.state.value) ? styles.focused : null}>{this.props.title} {this.props.required ? '*' : ''}</label>}
      <input
        ref={c => this.input = c}
        id={this.props.id}
        name={this.props.name}
        placeholder={this.props.design !== 'label' ? this.props.title : undefined}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onKeyDown={this.onReturn}
        disabled={this.props.inactive}
        placeholder={this.props.design === 'standard' && `${this.props.title} ${this.props.required ? '*' : ''}`}
        type={this.state.type}
        value={this.state.value}
        min={this.props.min}
        max={this.props.max}
        step={this.props.step}
        maxlength={this.props.maxlength}
        autocomplete={this.props.hideAutoComplete && 'new-password'}
      />
      {
        (this.props.isClearable && this.state.value) && <span className={classNames(styles.inputInline, styles.closeButton)} onClick={this.clearInput} />
      }
      {(this.props.showPasswordToggle && this.props.type === 'password' ) &&
        <span className={styles.inputInline} onClick={this.togglePassword}>
          {this.state.type === 'password' ? 'Show' : 'Hide'}
        </span>
      }
      {
        (this.props.error || this.state.error || this.props.description) &&
          <span className={styles.inputNote}>
            {this.props.description && <span id='desc' className={styles.descMessage}>
              {this.props.description}
            </span>}
            {(this.props.error || this.state.error) && <span id='inputError' className={styles.errorMessage}>
              {this.props.error || this.state.error}
            </span>}
          </span>
      }
    </div>
  }
}

Input.propTypes = {
  /** Input id */
  id: PropTypes.string,
  /* Name of input */
  name: PropTypes.string,
  /** Input title */
  title: PropTypes.string.isRequired,
  /** Class name for hte input */
  className: PropTypes.string,
  /** Required field? */
  required: PropTypes.bool,
  /* min number value allowed */
  min: PropTypes.number,
  /* max number value allowed */
  max: PropTypes.number,
  /* max length of value */
  maxlength: PropTypes.number,
  /** Component state: enabled/disabled */
  inactive: PropTypes.bool,
  /** Error message (if available) */
  error: PropTypes.string,
  /** Desc to place under input */
  description: PropTypes.string,
  /** Fill input field with value */
  value: PropTypes.string,
  /** Design Style */
  design: PropTypes.oneOf(['label', 'standard']),
  /** OnChange event */
  onChange: PropTypes.func,
  /** Enter key press event */
  onReturn: PropTypes.func,
  /** Blur event */
  onBlur: PropTypes.func,
  /** html input type */
  type: PropTypes.string,
  /** Clear the field on key return */
  clearOnReturn: PropTypes.bool,
  /** Render toggle button to Show/Hide password */
  showPasswordToggle: PropTypes.bool,
  /** step attribute specifies the interval between legal numbers in an <input> element */
  step: PropTypes.string,
  /* Size of input font */
  size: PropTypes.oneOf(['small', 'default', 'blank']),
  /* Auto Complete chrome */
  hideAutoComplete: PropTypes.bool
}
Input.defaultProps = {
  design: 'label',
  showPasswordToggle: true,
  size: 'default',
  hideAutoComplete: false
}

export default Input
